<template>
  <div
    class="form formSignupAppeal"
    v-if="showComplete"
    @click.self="closeModal"
  >
    <div class="box">
      <div class="contents">
        <div class="signupAppeal">
          <div class="icon"></div>
          <h3>投稿が完了しました</h3>
          <div>※ 投稿はALOCOの承認後に表示されます。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showComplete: false,
  },
  computed: {
    show: {
      get: function () {
        return this.showComplete;
      },
      set: function (value) {
        this.$emit("input", value); // おやでは @input に書いたメソッドがよばれる。引数にvalue
      },
    },
  },
  methods: {
    closeModal() {
      this.show = false;
    }
  }
};
</script>
<style lang="scss">
.signupAppeal {
  .icon {
    width: 3.6rem;
    aspect-ratio: 1;
    background: url(/assets/img/common/complete.svg) center center/contain
      no-repeat;
    margin: 0 auto 0.8rem !important;
  }
}
</style>
